import img01 from '../images/banner/banner-shapes/01.png';
import img02 from '../images/banner/banner-shapes/02.png';
import img03 from '../images/banner/banner-shapes/03.png';
import img04 from '../images/banner/banner-shapes/04.png';
import img05 from '../images/banner/banner-shapes/05.png';
import img06 from '../images/banner/banner-shapes/06.png';
import img07 from '../images/banner/banner-shapes/07.png';
import img08 from '../images/banner/banner-shapes/08.png';
export const animatedImages=[img01,img02,img03,img04,img05, img06,img07 ,img08];